<template>
  <div class="container device_list">
    <div class="search_box flex_start_center">
      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">状态：</div> -->
        <div>
          <el-select v-model="is_bind" style="width:100px;">
            <el-option label="在院" value="1"></el-option>
            <el-option label="离院" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">状态：</div> -->
        <div>
          <el-select v-model="bind_status" style="width:100px;">
            <el-option label="全部" value="0"></el-option>
            <el-option label="绑定中" value="1"></el-option>
            <el-option label="未绑定" value="2"></el-option>
          </el-select>
        </div>
      </div>
      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">佩戴开始日期：</div> -->
        <div>
          <el-date-picker style="width:220px;" v-model="start_time" type="date" placeholder="选择佩戴开始日期"
            format="yyyy-MM-dd" value-format="timestamp" :clearable="false"
            :picker-options="startPickerOptions"></el-date-picker>
        </div>
      </div>

      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">床位号：</div> -->
        <div>
          <el-input placeholder="请输入床位号" style="width:180px;" v-model="bed_number"
            @keyup.enter.native="search"></el-input>
        </div>
      </div>
      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">患者住院号：</div> -->
        <div>
          <el-input placeholder="请输入患者住院号" style="width:180px;" v-model="patient_id"
            @keyup.enter.native="search"></el-input>
        </div>
      </div>
      <div class="flex_start_center mr_12">
        <!-- <div class="mr_12">患者住院号：</div> -->
        <div>
          <el-input placeholder="请输入患者姓名" style="width:180px;" v-model="name" @keyup.enter.native="search"></el-input>
        </div>
      </div>
      <!-- <el-button type="primary" @click="search">搜索</el-button> -->
      <div class="custom_btn primary_btn" @click="search">搜索</div>
      <div class="custom_btn warning_btn" @click="reset">重置</div>
      <!-- <el-button type="warning" @click="reset">重置</el-button> -->
    </div>
    <div class="table">
      <el-table :data="tableData" v-loading="table_loading" style="width: 100%" border>
        <el-table-column label="序号" align="center">
          <template slot-scope="scope">{{ scope.$index }}</template>
        </el-table-column>
        <el-table-column label="所在病区" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.zone_name }}（{{ scope.row.zone_number }}）</template>
        </el-table-column>
        <el-table-column prop="bed_number" label="床位" align="center"></el-table-column>
        <el-table-column prop="ccid" label="设备编号" align="center" width="240"></el-table-column>
        <el-table-column prop="bind" label="设备状态" align="center" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.bind == 1 ? "绑定中" : "未绑定" }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="patient_id" label="住院号" align="center" width="100"></el-table-column>
        <el-table-column prop="name" label="患者姓名" align="center" width="100"></el-table-column>
        <el-table-column prop="bind_time" label="佩戴开始时间" width="230" align="center"></el-table-column>
        <el-table-column label="心率预警阈值" align="center" width="160">
          <template slot-scope="scope">
            <div>最低值{{ scope.row.low_heartrate_value }}bpm</div>
            <div>最高值{{ scope.row.high_heartrate_value }}bpm</div>
          </template>
        </el-table-column>
        <el-table-column label="血氧预警阈值" align="center" width="300">
          <template slot-scope="scope">
            <div>最低值{{ scope.row.spo2 }}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="ppg" label="表端采集频率" align="center" width="130">
          <template slot-scope="scope">{{ scope.row.ppg }}分钟/次</template>
        </el-table-column>
        <el-table-column prop="normal_rate" label="表端上传频率" align="center" width="130">
          <template slot-scope="scope">{{ scope.row.normal_rate }}/次</template>
        </el-table-column>
        <el-table-column label="离院预警" align="center" width="100">
          <template>
            <div class="circle">已开启</div>
          </template>
        </el-table-column>
        <el-table-column label="SOS报警" align="center" width="100">
          <template>
            <div class="circle">已开启</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="400" fixed="right">
          <template slot-scope="scope">
            <div class="flex_box">
              <div @click="handlePrintReport(scope.row)" class="printReport">
                <img src="../../assets/print.png" alt />
                <div class="mr10 ml10">导出报告</div>
                <img v-if="scope.row.is_print == 1" src="../../assets/icon_no_print.png" alt="">
                <img v-else src="../../assets/icon_is_print.png" alt="">
              </div>
              <div @click="editData(scope.row)" class="printReport green_font">
                <img src="../../assets/edit_data_icon.png" alt />
                <div class="ml10">数值调整</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block flex_space_between">
        <div style="font-size: 18px;color: #777777;">提供打印护理记录的功能，并默认参考手表采集的数据，但可修改，实际以医护工作为准。</div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
          :page-sizes="[8]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>

    <div class="print_box" v-show="showPrint">
      <div id="print_container">
        <div class="print_title">
          武汉同济{{ printObj.zone.zone_name }}病区{{ printObj.zone.bed_number }}床
          <br />护理服务报告
        </div>
        <table border="0" cellspacing="0">
          <tr>
            <td class="table_bg" style=" width:240px;">患者姓名</td>
            <td>{{ print_name }}</td>
          </tr>
          <tr>
            <td class="table_bg" style=" width:240px;">住院号</td>
            <td>{{ printObj.zone.patient_id }}</td>
          </tr>
          <tr v-for="(item, index) in printObj.interval_time" :key="index">
            <td class="table_bg" style=" width: 240px;">统计时间</td>
            <td>{{ item }}</td>
          </tr>
          <tr>
            <td class="table_bg" style=" width: 240px;">统计小时数</td>
            <td>{{ printObj.interval_data }}</td>
          </tr>
        </table>
        <div class="part_title">1、心率监测情况（住院期间）</div>
        <div class="part_text">
          平均心率为 {{ printObj.heartrate_average }} 次/分，最高心率 {{ printObj.heartrate_max }} 次/分，最低心率
          {{ printObj.heartrate_min }} 次/分；
        </div>
        <div class="part_title">2、血氧监测情况（住院期间）</div>
        <div class="part_text">
          平均血氧为 {{ printObj.spo2_average }} %，最高血氧 {{ printObj.spo2_max }}%，最低血氧
          {{ printObj.spo2_min }}%；
        </div>
        <div class="part_title">3、心率血氧整体区间分布（住院期间）</div>
        <table border="0" cellspacing="0" v-if="printObj.heartrate_section">
          <tr>
            <td class="table_bg" style=" width: 190px;">采集指标</td>
            <td class="table_bg">分布区间</td>
            <td class="table_bg" style=" width: 190px;">出现次数</td>
            <td class="table_bg" style=" width: 170px;">占比</td>
          </tr>
          <tr>
            <td rowspan="4">心率</td>
            <td>心率＜45次/分</td>
            <td>{{ printObj.heartrate_section['< 45'].number }}</td>
            <td>{{ printObj.heartrate_section['< 45'].compare }}</td>
          </tr>
          <tr>
            <td>45次/分≤心率≤80次/分</td>
            <td>{{ printObj.heartrate_section['45 - 80'].number }}</td>
            <td>{{ printObj.heartrate_section['45 - 80'].compare }}</td>
          </tr>
          <tr>
            <td>80次/分≤心率≤120次/分</td>
            <td>{{ printObj.heartrate_section['80 - 120'].number }}</td>
            <td>{{ printObj.heartrate_section['80 - 120'].compare }}</td>
          </tr>
          <tr>
            <td>心率＞120次/分</td>
            <td>{{ printObj.heartrate_section['> 120'].number }}</td>
            <td>{{ printObj.heartrate_section['> 120'].compare }}</td>
          </tr>
          <tr>
            <td rowspan="4">血氧</td>
            <td>血氧＜80%</td>
            <td>{{ printObj.spo2_section['< 80'].number }}</td>
            <td>{{ printObj.spo2_section['< 80'].compare }}</td>
          </tr>
          <tr>
            <td>80%≤血氧＜90%</td>
            <td>{{ printObj.spo2_section['80 - 90'].number }}</td>
            <td>{{ printObj.spo2_section['80 - 90'].compare }}</td>
          </tr>
          <tr>
            <td>90%≤血氧＜95%</td>
            <td>{{ printObj.spo2_section['90 - 95'].number }}</td>
            <td>{{ printObj.spo2_section['90 - 95'].compare }}</td>
          </tr>
          <tr>
            <td>血氧＞95%</td>
            <td>{{ printObj.spo2_section['> 95'].number }}</td>
            <td>{{ printObj.spo2_section['> 95'].compare }}</td>
          </tr>
        </table>
        <div v-if="printObj.interval_time && printObj.interval_time.length <= 2" class="print_page"></div>
        <div class="part_title">4、数据采集明细数据（住院期间）</div>
        <div v-for="(list, index) in this.printObj.data_list_l" :key="index"
          :class="{ print_page: index != 0, table_padding: index != 0 }">
          <table border="0" cellspacing="0">
            <thead>
              <tr>
                <th class="table_bg">采集指标</th>
                <th class="table_bg">采集时分秒</th>
                <th class="table_bg">心率采集结果</th>
                <th class="table_bg">血氧采集结果</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in list" :key="i">
                <td>{{ $dateFtt.dateFtt('yyyy-MM-dd', new Date(item.insert_time * 1000)) }}</td>
                <td>{{ $dateFtt.dateFtt('hh:00:00', new Date(item.insert_time * 1000)) }}</td>
                <td>{{ item.heartrate }}（次/分）</td>
                <td>{{ item.spo2 }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="ele_dialog" title="低电量提醒" width="900px" class="el_dialog">
      <div class="dialog_tips">请及时进行设备充电！</div>
      <el-table v-loading="dialogTableLoading" :key="tableKey" :data="dialogTableData"
        style="width: 100%; margin-bottom: 20px" border height="334px">
        <el-table-column align="center" prop="ccid" label="设备CCID" width="200px"></el-table-column>
        <el-table-column align="center" prop="bed_number" label="床号"></el-table-column>
        <el-table-column align="center" prop="name" label="姓名"></el-table-column>
        <el-table-column align="center" prop="bat" label="电量">
          <template slot-scope="scope">
            <div style="color:red;">{{ scope.row.bat }}%</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="insert_time" label="电量同步时间" width="180px">
          <template slot-scope="scope">
            {{ scope.row.insert_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(scope.row.insert_time *
              1000))
              : '' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" class="table_btn_primary" @click="editBatStatus(scope.row, scope.$index)"
              size="small" v-show="scope.row.status !== 1">处理</el-button>
            <el-button type="default" class="table_btn_primary" disabled size="small"
              v-show="scope.row.status == 1">已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @current-change="handleDialogCurrentChange" :page-sizes="[5]"
        :current-page="dialog_page" :page-size="5" layout="sizes,prev, pager, next,total"
        :total="dialog_total"></el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="eidtdataDialog" title="数值调整" width="1200px" class="el_dialog" @close="editFlag = false">
      <div class="editDataTable">
        <div class="dialog_search flex_space_between">
          <el-date-picker v-model="editDataDate" type="date" placeholder="选择日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :clearable="false" :picker-options="pickerOptions"
            @change="dateChange"></el-date-picker>

          <div class="flex_start">
            <div class="custom_btn primary_btn" @click="handleEditData" v-if='!editFlag'>修改数值</div>
            <div class="custom_btn success_btn" @click="confirmEditData" v-else>确认修改</div>
            <div class="custom_btn primary_btn" @click="openEditDataLogDialog">调整记录</div>
          </div>
        </div>
        <el-table :data="editDialogTableData" height="500" v-loading="editDialogTableLoading">
          <el-table-column prop="insert_day" label="采集指标" align="center"></el-table-column>
          <el-table-column prop="insert_day" label="采集时分秒" align="center">
            <template slot-scope="scope">{{ $dateFtt.dateFtt('hh:00:00', new Date(scope.row.insert_time *
              1000)) }}</template>
          </el-table-column>
          <el-table-column align="center" prop="heartrate" label="心率采集结果">
            <template slot-scope="scope">
              <div v-if="editFlag" class="flex_center">
                <el-input v-model="editDataList[scope.$index].heartrate" style="width:117px;"></el-input>
                <span>（次/分）</span>
              </div>
              <div v-else>{{ scope.row.heartrate ? scope.row.heartrate : '--' }}（次/分）</div>

            </template>
          </el-table-column>
          <el-table-column align="center" prop="spo2" label="血氧采集结果">
            <template slot-scope="scope">
              <div v-if="editFlag" class="flex_center">
                <el-input v-model="editDataList[scope.$index].spo2" style="width:117px;"></el-input>
                <span>%</span>
              </div>
              <div v-else>{{ scope.row.spo2 ? scope.row.spo2 : '--' }} %</div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.edit_status" type="success" plain
                @click="confirmEdit(scope.$index)">确认</el-button>
              <el-button v-else type="primary" plain @click="eidtStatus(scope.$index)">调整</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="eidtdataLogDialog" title="调整记录" width="1200px" class="el_dialog">
      <el-table :data="logTableData" height="500" v-loading="logLoading">
        <el-table-column label="采集指标" align="center">
          <template slot-scope="scope">{{ $dateFtt.dateFtt('yyyy-MM-dd', new Date(scope.row.insert_time *
            1000)) }}</template>
        </el-table-column>
        <el-table-column label="采集时分秒" align="center">
          <template slot-scope="scope">{{ $dateFtt.dateFtt('hh:00:00', new Date(scope.row.insert_time *
            1000)) }}</template>
        </el-table-column>
        <el-table-column prop="d_heartrate" label="调整前(心率)" align="center"></el-table-column>
        <el-table-column prop="heartrate" label="调整后(心率)" align="center"></el-table-column>
        <el-table-column prop="d_spo2" label="调整前(血氧)" align="center"></el-table-column>
        <el-table-column prop="spo2" label="调整后(血氧)" align="center"></el-table-column>
        <el-table-column prop="create_date" label="调整时间" align="center" width="180"></el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @current-change="handleLogCurrentChange" :current-page="logPage.page" :page-size="logPage.limit"
          layout="total, prev, pager, next, jumper" :total="logPage.total"></el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="chooseDateDialog" title="合并报告" width="1200px" v-loading="!printFlag" class="el_dialog">
      <div class="height400">
        <div class="report_date_list">
          <div v-for="(item, index) in reportDateList">
            <el-checkbox v-model="mergeList[index]" style="width:100%;margin-bottom: 10px;" size="large"
              :label="`${item.bed_number}床——${item.bind_time_date} ~ ${item.unbind_time_date}`" border></el-checkbox>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex_center_center">
          <div class="custom_btn primary_btn" @click="confirmMergePrint(trueLength <= 1)" v-if="trueLength <= 1"
            :class="{ diabled_btn: trueLength == 0 }">
            直接打印</div>
          <div class="custom_btn primary_btn" @click="confirmMergePrint(!nonsequence)" v-else
            :class="{ diabled_btn: nonsequence }">合并打印</div>
        </div>

      </span>
    </el-dialog>
  </div>
</template>

<script>
import printCss from "../../assets/printcss";
export default {
  data() {
    return {
      editFlag: false,
      tableData: [],
      patient_id: "",
      bind_status: "1",
      name: "",
      bed_number: "",
      start_time: "",
      is_bind: '1',
      patient_id: "",
      page: 1,
      limit: 8,
      total: 0,
      zone_number: "",
      printObj: {
        zone: {},
      },
      table_loading: false,
      showPrint: false,
      print_name: "",
      ele_total: 0,
      ele_dialog: false,
      dialogTableData: [],
      dialogTableLoading: false,
      dialog_total: 0,
      dialog_page: 1,
      tableKey: 0,
      interval: "",
      eidtdataDialog: false,
      editDialogTableLoading: false,
      editDialogTableData: [],
      editDataForm: {
        spo2: "",
        heartrate: "",
      },
      pickerOptions: {
        disabledDate(date) {
          return new Date() < date;
        },
      },
      startPickerOptions: {
        disabledDate(date) {
          return new Date() < date;
        },
      },
      editDataDate: "",
      editDataPatient: {},
      eidtdataLogDialog: false,
      logTableData: [],
      logLoading: false,
      logPage: {
        page: 1,
        perPage: 10,
        total: 0
      },
      logPatient: {},
      chooseDateDialog: false,
      reportDateList: [],
      mergeList: [],
      mergeReportPatient: {},
      printFlag: true,
      editDataList: []
    };
  },
  computed: {
    nonsequence() {
      let arr = []
      this.mergeList.forEach((item, index) => {
        if (item) {
          arr.push(index)
        }
      })
      let i = arr[0];
      console.log(arr);
      let isContinuation = true;
      for (let e in arr) {
        if (arr[e] != i) {
          isContinuation = false;
          break;
        }
        i++;
      }
      return !isContinuation;
    },
    trueLength() {
      let num = 0
      this.mergeList.forEach((item) => {
        if (item) {
          num++
        }
      })
      return num
    }
  },
  mounted() {

    this.checkLogin();
    this.zone_number = localStorage.getItem("zone_number");
    this.fetchData();
    this.fetchBatNum();
    this.interval = setInterval(() => {
      this.fetchBatNum();
    }, 600000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    handleEditData() {
      this.editFlag = true
    },
    confirmEditData() {
      let editData = []
      let messageFlag_1 = false, messageFlag_2 = false, messageFlag_3 = false
      this.editDataList.forEach((item, index) => {
        // if (Number(item.heartrate) && item.heartrate != this.editDialogTableData[index].heartrate && !item.spo2) {
        //   messageFlag_1 = true
        // }
        // if (Number(item.spo2) && item.spo2 != this.editDialogTableData[index].spo2 && !item.heartrate) {
        //   messageFlag_2 = true
        // }
        if (item.heartrate != this.editDialogTableData[index].heartrate || item.spo2 != this.editDialogTableData[index].spo2) {
          editData.push({
            id: item.id,
            spo2: Number(item.spo2),
            heartrate: Number(item.heartrate)
          })
        }
      })
      editData.forEach(item => {
        if (!item.heartrate) {
          messageFlag_1 = true
        }
        if (!item.spo2) {
          messageFlag_2 = true
        }
        if (Number.isNaN(item.heartrate) || Number.isNaN(item.spo2)) {
          messageFlag_3 = true
        }
      })
      console.log(editData);
      if (messageFlag_3) {
        this.$message.error('数值格式不正确')
        return
      }
      if (messageFlag_1) {
        this.$message.error('请输入心率值')
        return
      }
      if (messageFlag_2) {
        this.$message.error('请输入血氧值')
        return
      }
      if (editData.length == 0) {
        this.editFlag = false
        return
      }
      let data = {
        zone_number: this.zone_number,
        data: editData
      }
      this.$http({
        url: "/api/output/reportEditMany",
        method: "POST",
        data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.$message.success('修改成功')
        this.editFlag = false
        this.fetchEditTableList()
      });
    },
    dateChange(e) {
      console.log(e);
      this.fetchEditTableList();
    },
    fetchBatNum() {
      let data = {
        zone_number: this.zone_number,
        page: this.dialog_page,
        perPage: 5,
      };
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.ele_total = res.result.total;
      });
    },
    editBatStatus(item, index) {
      this.dialogTableLoading = true;
      let data = { id: item.id };
      this.$http({
        url: "/api/hope/bat_status",
        method: "POST",
        data: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData[index].status = 1;
        this.$nextTick(() => {
          this.tableKey++;
        });
        this.fetchBatNum();
      });
    },
    handleDialogCurrentChange(e) {
      this.dialog_page = e;
      let data = {
        zone_number: this.zone_number,
        page: this.dialog_page,
        perPage: 5,
      };
      this.dialogTableLoading = true;
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData = res.result.data;
        this.dialogTableData.forEach((item, index) => {
          this.dialogTableData[index].status = 0;
        });
        this.dialog_total = res.result.total;
      });
    },
    openEleList() {
      this.dialog_page = 1;
      let data = {
        zone_number: this.zone_number,
        page: this.dialog_page,
        perPage: 5,
      };
      this.dialogTableLoading = true;
      this.$http({
        url: "/api/hope/bat",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.dialogTableLoading = false;
        this.dialogTableData = res.result.data;
        this.ele_dialog = true;
        this.dialog_total = res.result.total;
        this.dialogTableData.forEach((item, index) => {
          this.dialogTableData[index].status = 0;
        });
      });
    },
    checkLogin() {
      if (!localStorage.getItem("token")) {
        this.$router.push("/login");
      }
    },
    pageTo() {
      this.$router.push({
        path: "/all_device_data",
        query: {
          zone_number: this.zone_number,
        },
      });
    },
    handlePrintReport(item) {
      let data = {
        patient_id: item.patient_id,
        zone_number: this.zone_number,
        id: item.id
      }
      this.checkLogin()
      this.$http({
        url: "api/output/timeListMerge",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then(res => {
        // if (res.result.length > 1) {
        this.openChooseDateDialog(item, res.result)
        // } else if (res.result.length == 1) {
        // this.printReport(item)
        // }
      })
    },
    openChooseDateDialog(item, list) {
      this.mergeReportPatient = item
      this.reportDateList = list
      this.mergeList = []
      this.reportDateList.forEach(item => {
        this.mergeList.push(item.is_default == 1)
      })

      this.chooseDateDialog = true
    },

    confirmMergePrint(flag) {
      if (!flag || this.trueLength == 0) {
        return
      }
      if (!this.printFlag) {
        return
      }
      this.printFlag = false
      let ids = []
      let dates = []
      this.mergeList.forEach((item, index) => {
        if (item) {
          ids.push(this.reportDateList[index].id)
          dates.push({
            bind_time_date: this.reportDateList[index].bind_time_date,
            unbind_time_date: this.reportDateList[index].unbind_time_date,
            start: this.reportDateList[index].start,
            end: this.reportDateList[index].end
          })
        }
      });
      let data = {
        patient_id: this.mergeReportPatient.patient_id,
        zone_number: this.zone_number,
        id: ids,
        date: dates
      }
      this.$http({
        url: "api/output/reportMerge",
        method: "POST",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then(res => {
        this.print_name = this.mergeReportPatient.name;
        this.chooseDateDialog = false
        this.table_loading = false;
        this.printObj = res.result;
        this.printObj.zone = this.mergeReportPatient;
        let data_list = []
        for (const key in this.printObj.data_list) {
          if (Object.hasOwnProperty.call(this.printObj.data_list, key)) {
            const element = this.printObj.data_list[key];
            data_list.push(element)
          }
        }
        this.printObj.data_list_l = []
        for (let index = 0; index < Math.ceil(data_list.length / 19); index++) {
          this.printObj.data_list_l[index] = []

        }

        data_list.forEach((item, index) => {
          this.printObj.data_list_l[Math.floor((index) / 19)].push(item)
        })
        this.$nextTick(() => {
          this.printFn();
          this.fetchData();
          this.printFlag = true
        });
      })
        .catch((err) => {
          this.table_loading = false;
          this.printFlag = true
        });
    },
    printReport(item) {
      if (!this.printFlag) {
        return
      }
      this.printFlag = false
      let data = {
        ccid: item.ccid,
        start: item.start,
        end: item.end,
        patient_id: item.patient_id,
        zone_number: this.zone_number,
        id: item.id,
      };
      this.print_name = item.name;
      this.checkLogin();
      this.table_loading = true;
      this.$http({
        url: "api/output/signDateReport",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.table_loading = false;
          this.printObj = res.result;
          this.printObj.zone = item;
          let data_list = []
          for (const key in this.printObj.data_list) {
            if (Object.hasOwnProperty.call(this.printObj.data_list, key)) {
              const element = this.printObj.data_list[key];
              data_list.push(element)
            }
          }
          this.printObj.data_list_l = []
          for (let index = 0; index < Math.ceil(data_list.length / 20); index++) {
            this.printObj.data_list_l[index] = []

          }

          data_list.forEach((item, index) => {
            this.printObj.data_list_l[Math.floor((index) / 20)].push(item)
          })
          this.$nextTick(() => {
            this.printFn();
            this.fetchData();
            this.printFlag = true
          });
        })
        .catch((err) => {
          this.table_loading = false;
          this.printFlag = true
        });
    },
    printFn() {
      const printContent = document.querySelector("#print_container").innerHTML;
      // const iframe = document.createElement("iframe");
      // iframe.setAttribute("style", "position: absolute; width: 0; height: 0;");
      // document.body.appendChild(iframe);
      // const iframeDoc = iframe.contentWindow.document;
      // iframeDoc.write('<div id="print_container">' + printContent + "</div>");
      // iframeDoc.write(`<style media="print">${printCss}</style>`);
      const html = `
      <html>
        <style>${printCss}</style>
        <div id="print_container">${printContent}</div>
        </html>`

        // const win = window.open("", "打印预览", "width=800,height=600");
        // win.document.write(html);

      setTimeout(function () {
        // iframe.contentWindow.print();
        window.electron.sendPrint(html);
        // document.body.removeChild(iframe);
      }, 50);
    },
    handleSizeChange(e) {
      this.limit = e;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    search() {
      this.limit = 8;
      this.page = 1;
      this.fetchData();
    },
    reset() {
      this.limit = 8;
      this.page = 1;
      this.bed_number = "";
      this.patient_id = "";
      this.start_time = "";
      this.is_bind = "1";
      this.bind_status = '1'
      this.name = ''
      this.fetchData();
    },
    fetchData() {
      this.table_loading = true;
      this.checkLogin();
      let time = ''
      if (this.start_time) {
        time = (this.start_time / 1000).toFixed(0)
      }
      this.$http({
        url: "api/output/signDate",
        method: "GET",
        params: {
          page: this.page,
          limit: this.limit,
          bed_number: this.bed_number,
          zone_number: this.zone_number,
          patient_id: this.patient_id,
          start_time: time,
          is_bind: this.is_bind,
          bind_status: this.bind_status,
          name: this.name
        },
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        // console.log(res);
        this.table_loading = false;
        // let deleteIndex = []
        // arr.sort((a, b) => {
        //     return a.id - b.id
        // })
        // // console.log(this.tableData);
        // arr.forEach((item, index) => {
        //     arr.forEach((e, i) => {
        //         if (item.bed_number == e.bed_number && item.id != e.id) {
        //             deleteIndex.push(index)
        //         }
        //     })
        // })
        // deleteIndex.length = deleteIndex.length / 2
        // deleteIndex.forEach((item, index) => {
        //     arr.splice(item - index, 1)
        // // })
        // let arr = res.result.data
        // arr.sort((a, b) => {
        //     return b.id - a.id
        // })
        // this.tableData = this.removeSame5(arr, 'bed_number').sort((a, b) => {
        //     return a.id - b.id
        // })
        this.tableData = res.result.data;
        this.total = res.result.total;
      });
    },
    removeSame5(arr, prop) {
      // console.log(arr);
      let newArr = []; // 去重后得到的新数组
      const obj = {}; //  中间值 转换数据
      newArr = arr.reduce(function (pre, cur) {
        obj[cur[prop]] ? "" : (obj[cur[prop]] = true && pre.push(cur));
        return pre;
      }, []);
      return newArr;
    },
    editData(item) {
      this.eidtdataDialog = true;
      this.logPatient = item
      item.end = Number(item.end);
      item.start = Number(item.start);
      this.pickerOptions.disabledDate = (date) => {
        if (item.end) {
          if (
            new Date(
              this.$dateFtt.dateFtt(
                "yyyy-MM-dd 00:00:00",
                new Date(item.start * 1000)
              )
            ) <= date &&
            new Date(
              this.$dateFtt.dateFtt(
                "yyyy-MM-dd 23:59:59",
                new Date(item.end * 1000)
              )
            ) >= date
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          if (
            new Date(
              this.$dateFtt.dateFtt(
                "yyyy-MM-dd 00:00:00",
                new Date(item.start * 1000)
              )
            ) <= date &&
            new Date(
              this.$dateFtt.dateFtt("yyyy-MM-dd 23:59:59", new Date())
            ) >= date
          ) {
            return false;
          } else {
            return true;
          }
        }
      };
      if (item.end) {
        this.editDataDate = this.$dateFtt.dateFtt(
          "yyyy-MM-dd",
          new Date(item.end * 1000)
        );
      } else {
        this.editDataDate = this.$dateFtt.dateFtt("yyyy-MM-dd", new Date());
      }
      this.editDataPatient = item;
      this.fetchEditTableList();
    },
    fetchEditTableList() {
      this.editDialogTableLoading = true;
      let data = {
        ccid: this.editDataPatient.ccid,
        start: new Date(this.editDataDate + " 00:00:00").getTime() / 1000,
        end: new Date(this.editDataDate + " 23:59:59").getTime() / 1000,
        patient_id: this.editDataPatient.patient_id,
        zone_number: this.zone_number,
        id: this.editDataPatient.id,
        is_print: 1,
      };
      this.checkLogin();
      this.$http({
        url: "api/output/signDateEdit",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.editDialogTableLoading = false;
        this.editDialogTableData = res.result.data_list;
        // this.editDialogTableData.forEach((item, index) => {
        //   this.editDialogTableData[index].edit_status = false;
        // });
        this.editDataList = JSON.parse(JSON.stringify(this.editDialogTableData))
        console.log(this.editDialogTableData);
      });
    },
    eidtStatus(index) {
      let dataList = JSON.parse(JSON.stringify(this.editDialogTableData));
      dataList.forEach((item, i) => {
        dataList[i].edit_status = false;
      });
      dataList[index].edit_status = true;
      this.editDialogTableData = dataList;
      this.editDataForm = {
        heartrate: dataList[index].heartrate ? dataList[index].heartrate : "",
        spo2: dataList[index].spo2 ? dataList[index].spo2 : "",
      };
    },
    confirmEdit(index) {
      if (!this.editDataForm.heartrate) {
        this.$message.error("请输入心率值");
        return;
      }
      if (!this.editDataForm.spo2) {
        this.$message.error("请输入血氧值");
        return;
      }
      let data = {
        id: this.editDialogTableData[index].id,
        spo2: this.editDataForm.spo2,
        heartrate: this.editDataForm.heartrate,
        zone_number: this.zone_number,
      };
      this.$http({
        url: "api/output/reportEdit",
        method: "POST",
        data: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.fetchEditTableList();
        this.$message.success("编辑成功");
      });
    },
    openEditDataLogDialog() {
      this.eidtdataDialog = false;
      this.eidtdataLogDialog = true
      this.logPage.page = 1
      this.logPage.total = 0
      this.fetchLogList()
    },
    fetchLogList() {
      this.logLoading = true
      let data = {
        ccid: this.editDataPatient.ccid,
        patient_id: this.editDataPatient.patient_id,
        zone_number: this.zone_number,
        page: this.logPage.page,
        limit: this.logPage.perPage,
        start: this.logPatient.start,
        end: Number(this.logPatient.end) ? this.logPatient.end : (new Date().getTime() / 1000).toFixed(0)
      };
      this.checkLogin();
      this.$http({
        url: "api/output/reportEditList",
        method: "GET",
        params: data,
        headers: {
          Token: localStorage.getItem("token"),
        },
      }).then((res) => {
        this.logLoading = false;
        this.logTableData = res.result.data;
        this.logPage.total = res.result.total
      });
    },
    handleLogCurrentChange(e) {
      this.logPage.page = e
      this.fetchLogList()
    }
  },
};
</script>
<style scoped>
@import url('../../assets/style/commo.css');

.mr20 {
  margin-right: 20px;
}

.block {
  text-align: right;
  margin-top: 20px;
}

.circle {
  font-size: 14px;
  color: #07c160;
  position: relative;
}

.circle::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 8px;
  background-color: #07c160;
  left: 0;
  top: 7px;
}

.printReport {
  font-size: 18px;
  color: #0076f6;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  align-items: center;
  /* align-content: center; */
  background-color: #EBF4FF;
  height: 52px;
  border-radius: 12px;
  padding: 0 24px;
}

.printReport div {
  font-family: 'Source Han Sans CN-Medium';
}

.data_change {
  color: #07C160;
  background-color: #EBFAF3;
}

.mr10 {
  margin-right: 10px;
}

.ml10 {
  margin-left: 10px;
}

.printReport img {
  width: 28px;
  height: 28px;
  /* margin-right: 10px; */
}

.logo {
  position: absolute;
  right: 70px;
  top: 50px;
  width: 140px;
  opacity: 0.4;
}

.fix_phone {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 18px;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
  background-color: #409eff;
  color: #ffffff;
  border-bottom-left-radius: 10px;
}

.psr {
  position: relative;
}

.logo_box {
  height: 40px;
  /* width: auto; */
  position: absolute;
  right: 20px;
  top: 20px;
}

.logo_box img {
  height: 100%;
  width: auto;
  vertical-align: top;
}

.ele_btn {
  /* position: absolute; */
  margin-right: 20px;
}

/* .logo_box>>>.el-button--danger {
    background-color: red !important;
    border-color: red !important;
    padding-right: 50px;
    position: relative;
} */

.num {
  position: absolute;
  top: 10px;
  right: 20px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: #fff;
  color: red;
  text-align: center;
  line-height: 20px;
  font-weight: bold;
}

.pagination {
  text-align: center;
}

.dialog_tips {
  font-size: 16px;
  margin-bottom: 20px;
}

.flex_box {
  display: flex;
  justify-content: space-between;
}

.dialog_search {
  margin-bottom: 24px;
}

.height400 {
  height: 400px;
  overflow-y: auto;
}

.report_date_list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.report_date_list>div {
  width: 48%;
}

.device_list>>>.el-table .el-table__cell {
  padding: 16px 0;
}

.device_list>>>.el-table .el-table__header-wrapper .el-table__cell {
  padding: 20px 0;
}

.device_list>>>.el-table .el-table__fixed-right .el-table__cell {
  padding: 16px 0;
}

.report_date_list>>>.el-checkbox.is-bordered {
  padding: 20px;
  padding-top: 22px;
  background: #F5F7FB;
  border-radius: 8px;
  height: unset !important;
}

.report_date_list>>>.el-checkbox__label {
  font-size: 18px;
}

.green_font {
  color: #07C160 !important;
}






* {
    box-sizing: border-box;
    font-family: "宋体", SimSun, sans-serif;
}

#print_container {
    width:1040px;
    padding: 23px 46px 0px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color-adjust: exact;
}

.print_title {
    font-size: 42px;
    font-weight: bold;
    text-align: center;
    color: #323232;
    margin-bottom: 46px;
}

#print_container td,#print_container th {
    border-right: 1px solid #323232;
    border-bottom: 1px solid #323232;
    padding-left: 46px;
}

#print_container table {
    border-left: 1px solid #323232;
    border-top: 1px solid #323232;
    width: 100%;
    font-size: 32px;
    color: #323232;
}

#print_container tr {
    height: 64px;
}

.table_bg {
    background-color: #EEEEEE;
    font-weight: 500;
    font-size: 30px;
}

.part_title {
    color: #323232;
    font-size: 30px;
    font-weight: bold;
    margin-top: 40px;
    margin-bottom: 10px;
}

.part_text {
    color: #323232;
    font-size: 30px;
    font-weight: 300;
}
.print_page {
    page-break-after:left;
}
.table_padding {
padding-top:40px;}      
</style>


// WEBPACK FOOTER //
// src/view/managePages/device_list.vue